export default {
    path: '/complaintdetail',
    meta: {
        title: '投诉详情页',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/complaintdetail`),
}


// WEBPACK FOOTER //
// ./src/views/ComplaintDetail/router.js